export enum BadgeActionTypes {
  GoToPageBadgeAction = 'GoToPageBadgeAction',
  RequestCouponBadgeAction = 'RequestCouponBadgeAction',
  CopyCouponToCartBadgeAction = 'CopyCouponToCartBadgeAction',
}

export interface BadgeAction {
  code: string;
  name: string;
  type: keyof typeof BadgeActionTypes;
  couponId?: string;
  url?: string;
}

export interface Badge {
  canBeOpened: boolean;
  code: string;
  color: string;
  name: string;
  actions?: BadgeAction[];
  content?: string;
  title?: string;
}

export enum BadgeTypes {
  Promo = 'promo',
  Props = 'props',
}

export enum BadgeColors {
  Green = '#638258',
  Yellow = '#FFBD02',
  Red = '#C2171F',
  Gray = '#666666',
  Blue = '#4169B7',
}
